import { EditIcon } from '@assets/svgs/EditIcon'
import { TrashSimple } from '@assets/svgs/TrashSimple'
import { currencyMask } from '@utils/masks/currencyMask'
import { formattedDatePtBrDateOnly } from '@utils/dates/formattedDatePtBr'
import { UserGear } from '@phosphor-icons/react'

import type { SimulationCardProps } from './types'

import * as S from './styles'

export const SimulationCard = ({ simulation, onEdit, onDelete, canEdit = true }: SimulationCardProps) => {
  const simulationTypeLabel = simulation.simulationType || 'Simulação'
  const dateValue = simulation.startDate
  const simulationNumber = `Simulação #${String(simulation.id).padStart(3, '0')}`
  const normalizedType = simulation.simulationType?.toLowerCase()
  const isAdmission = normalizedType === 'admissao' || normalizedType === 'admissão'
  const displayValue = isAdmission ? simulation.proportionalSalary : simulation.balance

  return (
    <S.Card>
      <S.IconContainer>
        <UserGear size={20} weight="regular" color="#73A49F" />
      </S.IconContainer>
      
      <S.CardContent>
        <S.LeftSection>
          <S.TitleRow>
            <S.SimulationNumber>{simulationNumber}</S.SimulationNumber>
          </S.TitleRow>
          <S.InfoRow>
            <S.SimulationType>{simulationTypeLabel}</S.SimulationType>
            <S.Separator>|</S.Separator>
            <S.CurrencyValue>
              {displayValue !== null && displayValue !== undefined
                ? currencyMask(displayValue.toFixed(2))
                : 'R$ 0,00'}
            </S.CurrencyValue>
          </S.InfoRow>
        </S.LeftSection>
        
        <S.RightSection>
          <S.DateValue>{dateValue ? formattedDatePtBrDateOnly(dateValue) : '--/--/----'}</S.DateValue>
          {canEdit && (
            <S.ActionsContainer>
              <S.ActionButton onClick={() => onEdit(simulation)} title="Editar">
                <EditIcon />
              </S.ActionButton>
              <S.ActionButton onClick={() => onDelete(simulation)} title="Excluir">
                <TrashSimple />
              </S.ActionButton>
            </S.ActionsContainer>
          )}
        </S.RightSection>
      </S.CardContent>
    </S.Card>
  )
}
